import React from 'react';
import classNames from 'classnames';

import css from './IconRecenter.module.css';

/**
 * Geo/target icon for re-centering map.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @returns {JSX.Element} SVG icon
 */
const IconRecenter = props => {
  const { rootClassName, className } = props;
  const classes = classNames(rootClassName || css.root, className);
  return (
    <svg
      className={classes}
      width="24"
      height="24"
      viewBox="-5 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M11.188 4.781c6.188 0 11.219 5.031 11.219 11.219s-5.031 11.188-11.219 11.188-11.188-5-11.188-11.188 5-11.219 11.188-11.219zM11.969 20.75v3.594c4.031-0.344 7.25-3.594 7.594-7.594h-3.563v-1.469h3.563c-0.313-4.063-3.563-7.281-7.594-7.625v3.594h-1.469v-3.594c-4.063 0.313-7.344 3.563-7.656 7.625h3.625v1.469h-3.625c0.344 4.031 3.594 7.281 7.656 7.625v-3.625h1.469z" />
    </svg>
  );
};

export default IconRecenter;
